{
    "account": "Compte",
    "add_bookmark": "Ajouter aux marque-pages",
    "add_date": "Préciser une date",
    "ago": "Il y a {{duration}}",
    "api_key": "Clé d'API",
    "are_you_sure": "Êtes-vous sûr·e ?",
    "ask_delete_message": "Supprimer ce message ?",
    "audio_not_ready": "Le fichier audio n'est pas prêt.",
    "bookmark_added": "Message ajouté aux marque-pages.",
    "bookmark_removed": "Message supprimé des marque-pages.",
    "bookmarks": "marque-pages",
    "cancel": "Annuler",
    "cancel_write": "Voulez-vous annuler l'écriture d'un nouveau message ?",
    "changed_group_name": "a changé le nom du groupe",
    "confirm_password_placeholder": "confirmez le mot de passe",
    "connect": "Connexion",
    "create_a_group": "Créer un groupe",
    "create_the_group": "Créer le groupe",
    "daily": "Journalier",
    "default_group": "Groupe par défaut",
    "delete": "Supprimer",
    "destroy_account_explain": "Une fois votre compte supprimé, il sera impossible d'annuler l'opération.",
    "destroy_account": "Supprimer votre compte",
    "edit": "Modifier",
    "email": "Courriel",
    "email_input": "Saisissez votre adresse électronique ici",
    "empty_message": "Le message est vide et ne peut pas être envoyé.",
    "error_new_message": "Une erreur s’est produite lors de l’envoi de votre message.",
    "error": "Une erreur s'est produite",
    "error_upload": "Une erreur s'est produite pendant le téléversement",
    "forgot_password": "Mot de passe oublié ?",
    "group_left": "Vous avez quitté le groupe.",
    "groups": "Groupes",
    "group_share_choice": "À quel groupe voulez-vous envoyer ce message ?",
    "group_updated": "Le groupe a été mis à jour.",
    "has_commented_on": "a commenté",
    "has_joined": "a rejoint",
    "has_left": "a quitté",
    "has_posted_in": "a posté dans",
    "hourly": "Une fois par heure",
    "in": "dans",
    "Invalid login/password": "Identifiant ou mot de passe invalide",
    "invitation_link": "Lien d'invitation",
    "invitation_welcome": "Bienvenue sur Zusam. Veuillez vous inscrire avant de rejoindre le groupe.",
    "just_now": "À l'instant",
    "lang": "langue",
    "login_input": "Choisissez un identifiant",
    "login_placeholder": "courriel",
    "login": "Se connecter",
    "logout": "Se déconnecter",
    "mark_all_as_read": "tout marquer comme lu",
    "monthly": "Mensuelle",
    "multiple_photos_upload": "Une erreur s'est produite. Essayez de téléverser les images une par une (cela peut se produire dans certains navigateurs)",
    "name_input": "Choisissez un nom",
    "name": "Nom",
    "new_password_placeholder": "nouveau mot de passe",
    "next_coms": "Voir les commentaires suivants",
    "none": "Aucune",
    "notification_emails": "Notifications par courriel",
    "notification_emails_stopped": "Notifications par courriel désactivées !",
    "notifications": "notifications",
    "parent_message": "Message parent",
    "password_input": "Entrez un nouveau mot de passe",
    "password": "Mot de passe",
    "password_placeholder": "mot de passe",
    "password_reset_mail_sent": "Recherchez le courriel de réinitialisation de mot de passe dans votre boîte de réception.",
    "passwords_dont_match": "Les mots de passe ne correspondent pas",
    "previous_coms": "Voir les commentaires précédents",
    "public_link": "lien public",
    "publish_in_group": "publier dans le groupe",
    "quit_group": "Quitter le groupe",
    "react": "Réagir",
    "remove_bookmark": "Supprimer des marque-pages",
    "replies_one": "{{count}} réponse",
    "replies_other": "{{count}} réponses",
    "reply": "répondre",
    "reset_api_key": "Changer votre clef d'API (vous allez être déconnecté)",
    "reset_invitation_link": "Réinitialiser le lien d'invitation",
    "reset_password_title": "Réinitialisation de votre mot de passe",
    "save_changes": "Enregistrer les changements",
    "search_in_group": "rechercher dans le groupe",
    "search_without_result": "Votre recherche ne correspond à aucun message.",
    "settings": "Paramètres",
    "settings_updated": "Vos paramètres ont été mis à jour",
    "share_message": "partager le message",
    "signup": "S'inscrire",
    "submit": "Envoyer",
    "text_placeholder": "Écrivez votre message ici",
    "the_message_from": "le message de",
    "title_placeholder": "Titre de votre message (optionnel)",
    "to": "en",
    "upload_audio": "Ajouter un fichier audio.",
    "upload_image": "Ajouter des photos",
    "upload_music": "Ajouter des musiques",
    "upload_pdf": "Ajouter un PDF",
    "upload_video": "Ajouter une vidéo",
    "User not found": "Utilisateur inexistant",
    "users": "utilisateurs",
    "video_not_ready": "La vidéo n'est pas encore prête.",
    "weekly": "Hebdomadaire",
    "you_have_no_bookmarks": "Vous n'avez pas de marques-pages."
}
